import { soadCTO11Part1DataSchema } from "../../schemas/index.js";
export const soadCTO11Part1Template = {
    signing: {
        userOrTeamRequirement: {
            accreditation: [],
            teamType: ["soad"],
        },
    },
    formBuilderFields: [
        {
            type: "practitioner",
            field: "practitioner",
            label: "SOAD name and address",
            hideWarningBanners: true,
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I am a registered medical practitioner appointed for the purposes of Part 4 of the Act (a SOAD), and have consulted",
            ],
        },
        // Consultees
        {
            type: "label",
            showStaticLabel: true,
            label: ["Consultee’s Full Name and Profession"],
        },
        {
            type: "readonly",
            textFn: (_data, context) => {
                const part4 = context.previousPartsFormData.find((s) => s.section === "consulteeDetails")?.data;
                const firstConsulteeName = part4?.firstConsulteeName?.trim();
                const firstConsulteeProfession = part4?.firstConsulteeProfession?.trim();
                const secondConsulteeName = part4?.secondConsulteeName?.trim();
                const secondConsulteeProfession = part4?.secondConsulteeProfession?.trim();
                return firstConsulteeName &&
                    firstConsulteeProfession &&
                    secondConsulteeName &&
                    secondConsulteeProfession
                    ? [
                        `${firstConsulteeName}, ${firstConsulteeProfession}`,
                        `${secondConsulteeName}, ${secondConsulteeProfession}`,
                    ]
                    : ["Please complete the Consultee Details section."];
            },
            afterLabel: "Taken from the ‘Consultee Details’ section which you completed earlier.",
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "who have been professionally concerned with the medical treatment of the above named patient, who is subject to a community treatment order.",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I certify that it is appropriate for the following treatment to be given to this patient while the patient is not recalled to hospital, subject to any conditions specified below.",
            ],
        },
        {
            type: "textbox",
            field: "treatmentNotRecalled",
            label: "Give description of treatment or plan of treatment, while the patient is not recalled to hospital",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [
                        part5?.planAuthorisedMedication,
                        part5?.timeLimitCertificateDuration,
                    ]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Treatment plan",
            },
        },
        {
            type: "textbox",
            field: "conditionsNotRecalled",
            label: "Specify the conditions of treatment (if any)",
            rows: "5",
            afterLabel: "Conditions may include time-limits on the approval of any or all of the treatment",
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I certify that it is appropriate for the following treatment (if any) to be given to this patient following any recall to hospital under section 17E of the Act, subject to any conditions specified below. ",
            ],
        },
        {
            type: "textbox",
            field: "treatmentAfterRecall",
            label: "Give description of treatment or plan of treatment, if the patient is recalled to hospital",
            rows: "5",
        },
        {
            type: "textbox",
            field: "conditionsAfterRecall",
            label: "Specify the conditions (if any) to apply to the treatment which may be given to the patient following any recall to hospital under section 17E",
            rows: "5",
            afterLabel: "Conditions may include time-limits on the approval of any or all of the treatment.",
        },
        {
            type: "textbox",
            field: "reasons",
            label: "My reasons are as below",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part2 = context.previousPartsFormData.find((s) => s.section === "diagnosisAndHistory")?.data;
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [
                        part2?.diagnosis,
                        part2?.assessment,
                        part5?.timeLimitCertificateReason,
                        part5?.interimS61Reasons,
                    ]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Reasons",
            },
            afterLabel: "When giving reasons please indicate if, in your opinion, disclosure of the reasons to the patient would be likely to cause serious harm to the physical or mental health of the patient, or to that of another person",
        },
        {
            type: "branch",
            field: "disclosureHarmful",
            label: "Would disclosure of these reasons to the patient be likely to cause serious harm to the physical or mental health of the patient, or of any other person?",
            afterLabel: "Recording yes adds a warning for anyone viewing this certificate. It does not appear on the certificate itself or the downloaded PDF.",
            branches: [
                { fieldValue: false, label: "No", fields: [], fieldsOwned: [] },
                { fieldValue: true, label: "Yes", fields: [], fieldsOwned: [] },
            ],
        },
    ],
    dataSchema: soadCTO11Part1DataSchema,
};
export const soadCTO11V1Base = {
    id: "mha-soad-cto11",
    category: "soad",
    version: "1.0",
    status: "active",
    formName: "CTO11",
    section: "64C(4)",
    parts: [soadCTO11Part1Template],
    description: "Certificate of appropriateness of treatment to be given to community patient (Part 4A certificate)",
    extractGenericData: () => ({}),
};
//# sourceMappingURL=soad-cto11.js.map